import { useEffect, useRef } from 'react';
import { TRIP_DEST } from '../../utils/assignCars';
import { YSRouteMapWrap } from './YS.styles';

const YSOverviewMap = ({ participants, type, onClose }) => {
    const mapRef = useRef(null);
    const markersRef = useRef([]);

    useEffect(() => {
        drawMap();
        return () => {
            markersRef.current.forEach(m => m.setMap(null));
            markersRef.current = [];
        };
    }, [type]);

    const drawMap = () => {
        const container = mapRef.current;
        if (!container) return;

        const map = new window.google.maps.Map(container, {
            center: { lat: 37.5, lng: 127.0 },
            zoom: 10,
            disableDefaultUI: true,
            zoomControl: true,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false
        });

        const bounds = new window.google.maps.LatLngBounds();

        // 화담숲 마커 (커스텀 오버레이)
        const destPos = { lat: TRIP_DEST.lat, lng: TRIP_DEST.lon };
        const destDiv = document.createElement('div');
        destDiv.style.cssText = `
            background: #198754;
            color: #fff;
            border: 2px solid #146c43;
            border-radius: 14px;
            padding: 3px 8px;
            font-size: 11px;
            font-weight: 600;
            font-family: S-Core-Dream, sans-serif;
            white-space: nowrap;
            box-shadow: 0 1px 4px rgba(0,0,0,0.2);
            transform: translate(-50%, -50%);
        `;
        destDiv.textContent = '화담숲';

        const destOverlay = new window.google.maps.OverlayView();
        destOverlay.onAdd = function () {
            this.getPanes().floatPane.appendChild(destDiv);
        };
        destOverlay.draw = function () {
            const proj = this.getProjection();
            const point = proj.fromLatLngToDivPixel(new window.google.maps.LatLng(destPos.lat, destPos.lng));
            destDiv.style.position = 'absolute';
            destDiv.style.left = point.x + 'px';
            destDiv.style.top = point.y + 'px';
        };
        destOverlay.onRemove = function () {
            destDiv.remove();
        };
        destOverlay.setMap(map);

        markersRef.current.push({ setMap: (m) => destOverlay.setMap(m) });
        bounds.extend(destPos);

        // 참여자 마커 (커스텀 오버레이)
        participants.forEach(p => {
            const loc = type === 'departure' ? p.departure : p.destination;
            const pos = { lat: loc.lat, lng: loc.lon };

            const labelText = type === 'departure'
                ? `${p.name} ${p.departureTime}${p.hasCar ? ' 🚗' + p.seats : ''}`
                : `${p.name}${p.hasCar ? ' 🚗' : ''}`;

            const div = document.createElement('div');
            div.style.cssText = `
                background: ${p.hasCar ? '#0d6efd' : '#fff'};
                color: ${p.hasCar ? '#fff' : '#333'};
                border: 2px solid ${p.hasCar ? '#0b5ed7' : '#0d6efd'};
                border-radius: 14px;
                padding: 3px 8px;
                font-size: 11px;
                font-weight: 600;
                font-family: S-Core-Dream, sans-serif;
                white-space: nowrap;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
                cursor: default;
                transform: translate(-50%, -50%);
            `;
            div.textContent = labelText;

            const overlay = new window.google.maps.OverlayView();
            overlay.onAdd = function () {
                this.getPanes().floatPane.appendChild(div);
            };
            overlay.draw = function () {
                const proj = this.getProjection();
                const point = proj.fromLatLngToDivPixel(new window.google.maps.LatLng(pos.lat, pos.lng));
                div.style.position = 'absolute';
                div.style.left = point.x + 'px';
                div.style.top = point.y + 'px';
            };
            overlay.onRemove = function () {
                div.remove();
            };
            overlay.setMap(map);

            markersRef.current.push({ setMap: (m) => overlay.setMap(m) });
            bounds.extend(pos);
        });

        map.fitBounds(bounds, 50);
    };

    return (
        <YSRouteMapWrap>
            <div className='mapHeader'>
                <span className='mapTitle'>
                    {type === 'departure' ? '출발 현황' : '도착 현황'}
                </span>
                <svg className="closeBtn" onClick={onClose} width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <line x1="6" y1="6" x2="18" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="18" y1="6" x2="6" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </div>
            <div className='routeMap' ref={mapRef}></div>
            <div className='routeInfoBar'>
                <span>참여자 {participants.length}명</span>
                <span>차량 {participants.filter(p => p.hasCar).length}대</span>
            </div>
        </YSRouteMapWrap>
    );
};

export default YSOverviewMap;
